import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import VueLazyload from 'vue-lazyload';
import urls from '@/network/api.js'
import request from '@/network/request.js'
import tips from '@/config/Tips.js'
//使用全局前置守卫 beforeEach 来动态设置页面标题
// 监听路由变化并设置 TDK
router.beforeEach((to, from, next) => {
  // 获取目标路由的 meta 信息
  const meta = to.meta?to.meta:{
    title:'中和能电力设备河北有限公司',
    description:'中和能电力设备河北有限公司销售各种电子仪器仪表',
    keywords:'中和能电力设备河北有限公司、中和能、电力设备、河北有限公司'
  };
  // const title = meta.title || '中和能电力设备河北有限公司';
  // const description = meta.description || '中和能电力设备河北有限公司销售各种电子仪器仪表';
  // const keywords = meta.keywords || '中和能电力设备河北有限公司、中和能、电力设备、河北有限公司';
  const title = meta.title;
  const description = meta.description;
  const keywords = meta.keywords;
  // 设置页面标题
  document.title = title;

  // 设置页面描述和关键词
  const metaDescription = document.querySelector('meta[name="description"]');
  const metaKeywords = document.querySelector('meta[name="keywords"]');

  if (metaDescription) {
    metaDescription.content = description;
  } else {
    document.head.insertAdjacentHTML(
      'beforeend',
      `<meta name="description" content="${description}">`
    );
  }

  if (metaKeywords) {
    metaKeywords.content = keywords;
  } else {
    document.head.insertAdjacentHTML(
      'beforeend',
      `<meta name="keywords" content="${keywords}">`
    );
  }

  next();
});

// 预加载关键数据
async function initApp() {
  // 如果 localStorage 中没有网站信息，先加载
  if (!localStorage.getItem('WEBSITE_INFO')) {
    try {
      const req = new request(urls.m().websiteInfos);
      const res = await req.modeget();
      if (res.data.data) {
        localStorage.setItem('WEBSITE_INFO', JSON.stringify(res.data.data));
      }
    } catch (error) {
      console.error('预加载网站信息失败:', error);
    }
  }

  const app = createApp(App);
  app.use(store);
  app.use(router)
  app.use(ElementPlus,{locale: zhCn});
  app.use(VueLazyload);

  // 请求地址
  app.config.globalProperties.$urls = urls
  // 请求方法
  app.config.globalProperties.$request = request
  // 弹窗提示
 
  app.config.globalProperties.$tips = tips

  //全局引入element plus icon
  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component);
  }
  app.mount('#app')
}

// 启动应用
initApp();
